<template>
  <div id="competition">
    <Topbar
      v-if="this.$store.state.topbar_actions_visible"
      @action="fnAction"
    ></Topbar>
    <CompetitionCategory></CompetitionCategory>

    <div class="section-list">
      <div v-for="(item, index) in sections" class="section">
        <router-link :to="item.url" :event="item.disabled ? '' : 'click'">
          <div class="icon" :class="{ disabled: item.disabled }">
            <router-link :to="item.url + '/add'"
              ><div
                v-if="typeof item.add === 'undefined' || item.add"
                class="add"
              ></div
            ></router-link>
            <img class="img" :src="item.img" />
          </div>
          <div class="content">{{ item.name }}</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import CompetitionCategory from "@/components/ui/CompetitionCategory";
import Topbar from "@/components/ui/Topbar";
import { Api } from "@/core/api.js";
const api = new Api();

export default {
  name: "Competition",
  components: { CompetitionCategory, Topbar },
  data() {
    return {};
  },
  computed: {
    sections() {
      var oEvent = this.$store.getters["events/getCurrentEvent"]();
      var sections = [
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) +
            "/competition/groups"
          ).replace("//", "/"),
          name: i18n.t("competition.group.label"),
          img: "/img/users.svg",
          add: false,
        },
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) +
            "/competition/matchs"
          ).replace("//", "/"),
          name: i18n.t("competition.calendar.label"),
          img: "/img/event.svg",
          add: false,
        },
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) +
            "/competition/scoreboard"
          ).replace("//", "/"),
          name: i18n.t("competition.classification.label"),
          img: "/img/playoff.svg",
          add: false,
        },
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) +
            "/competition/stats"
          ).replace("//", "/"),
          name: i18n.t("competition.stat.label"),
          img: "/img/stats.svg",
          add: false,
        },
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) +
            "/competition/sanctions"
          ).replace("//", "/"),
          name: i18n.t("competition.sanction.label"),
          img: "/img/white_card.svg",
          add: false,
        },
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) +
            "/competition/injuries"
          ).replace("//", "/"),
          name: i18n.t("competition.injury.label"),
          img: "/img/white_injury.svg",
          add: false,
        },
      ];
      return sections;
    },
  },
  created() {
    var self = this;
    this.$overlay.loading();

    self.$overlay.hide();
  },
  methods: {
    fnAction(emit) {
      if (typeof emit.action === "undefined" || emit.action == null) return;
      switch (emit.action) {
        case "import":
          this.fnImport(emit.params);
          break;
        case "export":
          this.fnExport(emit.params);
          break;
        case "applyFilters":
          this.new_filters(emit.params);
          break;
        case "rel_club_event":
          this.fnRelClubEvent(emit.params);
          break;
        case "rel_hotel_event":
          this.fnRelHotelEvent(emit.params);
          break;
        case "destroy":
          this.fnDestroy(emit.params);
          break;
        case "mail_document":
          this.fnSendMailDocument(emit.params);
          break;
        case "generate_playoff":
          this.fnGeneratePlayoff(emit.params);
          break;
        case "teams_send_image_right":
          this.fnSendTeamsImageRight();
          break;
      }
    },
    fnExport(type) {
      this.$overlay.loading();
      switch (type) {
        case "list":
          this.exportList();
          break;
        case "report":
          this.exportReport();
          break;
        case "click":
          this.setVisibleImport();
          break;
        case "insurance":
          this.exportInsurance();
          break;
        case "gestor":
          this.exportGestoria();
          break;
        case "uniforms":
          this.exportUniforms();
          break;
        case "credentials":
          this.exportCredencials();
          break;
        case "campus_rooms":
          this.exportCampusRooms();
          break;
        case "campus_training":
          this.exportCampusTrainings();
          break;
        case "rooming_list":
          this.exportRoomingList();
          break;
        case "calendar":
          this.exportCalendar();
          break;
        case "matches":
          this.exportMatches();
          break;
      }
    },
    exportCalendar() {
      var self = this;
      return api
        .get("competition/export/match_hotels")
        .then(function (response) {
          self.$overlay.hide();
          const link = document.createElement("a");
          link.href = response.file;
          //todo get name file from url
          const name = response.file.split("/");
          link.setAttribute("download", name[name.length - 1]);
          document.body.appendChild(link);
          link.click();
        });
    },

    exportMatches() {
      var self = this;
      return api.get("competition/export/match").then(function (response) {
        self.$overlay.hide();
        const link = document.createElement("a");
        link.href = response.file;
        const name = response.file.split("/");
        link.setAttribute("download", name[name.length - 1]);
        document.body.appendChild(link);
        link.click();
      });
    },
  },
  filters: {
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

#container {
}

#competition {
  overflow-y: auto !important;

  .section-list {
    width: 100%;
    position: relative;
    overflow: hidden;
    text-align: center;

    a {
      text-decoration: none;
    }

    .section {
      width: 125px;
      height: 125px;
      display: inline-block;
      margin: 35px 20px;
      margin-top: 100px;
      position: relative;
      text-align: center;

      .icon {
        width: 80%;
        height: 80%;
        border-radius: 50%;
        padding: 20px;
        position: relative;
        display: inline-block;
        background-color: #222;
        border: 5px solid tint(#222, 70%);
        -webkit-transition: border 200ms ease-out;
        -moz-transition: border 200ms ease-out;
        -o-transition: border 200ms ease-out;
        transition: border 200ms ease-out;

        &.disabled {
          opacity: 0.5;
        }

        .add {
          width: 30px;
          height: 30px;
          background: url("/img/add_2.svg");
          background-color: $complem-color;
          border-radius: 50%;
          border: 1px solid var(--main-color);
          position: absolute;
          top: -5px;
          right: -5px;
          content: " ";
          background-size: 20px;
          background-position: center;
          background-repeat: no-repeat;
          -webkit-transition: all 200ms ease-out;
          -moz-transition: all 200ms ease-out;
          -o-transition: all 200ms ease-out;
          transition: all 200ms ease-out;

          &:hover {
            width: 35px;
            height: 35px;
          }
        }

        &:hover {
          border: 8px solid tint(#222, 70%);
        }

        img {
          position: absolute;
          height: 50%;
          width: auto;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .content {
        width: 100%;
        color: #192461;
        height: 30px;
        line-height: 30px;
        font-size: 18px;
        text-align: center;
        font-family: $text-light;
      }
    }
  }
}
</style>
